import CompanyImage from 'models/CompanyImage';

import Component from './component';

export interface Props {
	images: CompanyImage[];
	title: string;
}

Component.defaultProps = {};
export default Component;
